import React from 'react';
import {Svg} from "assets";
import {TextToolTip} from "../table";

export const DefaultUploadedFileCard = ({file, handleDelete}) => {

    const renderSize = (item) => {
        const bytes = item?.size;
        const KB = 1024;
        const MB = KB * 1024;

        if (bytes >= MB) {
            return (bytes / MB).toFixed(2) + ' MB';
        } else if (bytes >= KB) {
            return (bytes / KB).toFixed(2) + ' KB';
        } else {
            return bytes + ' bytes';
        }
    };

    return (
        <div className='default-uploaded-file-card-wrapper'>
            <div className='default-uploaded-file-card-block'>
                <Svg.UploadFileTypeSvg/>
                <div className='default-uploaded-file-card-box'>
                    {file?.file?.name &&
                        <TextToolTip
                            classNameText='default-uploaded-file-card-name'
                            text={file?.file?.name}
                            content={file?.file?.name}
                        />
                    }

                    {file?.file?.size &&
                        <p className='default-uploaded-file-card-size'>
                            {renderSize(file?.file)}
                        </p>
                    }
                </div>
            </div>

            <button
                onClick={handleDelete}
                type='button'
                className='reset-btn default-uploaded-file-card-delete'
            >
                <Svg.Trash2Svg/>
            </button>
        </div>
    );
};

